/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passkey_AddInputs */

const en_passkey_add = /** @type {(inputs: Passkey_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add passkey`)
};

const de_passkey_add = /** @type {(inputs: Passkey_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add passkey" |
*
* @param {Passkey_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const passkey_add = /** @type {((inputs?: Passkey_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_passkey_add(inputs)
	return en_passkey_add(inputs)
});